


















































import { Component, Watch } from 'vue-property-decorator';
import Mixin from '@/mixin';
import VGoalItem from '@/components/goals/VGoalItem.vue';
import goalModule from '@/store/modules/common/goal.module';
import _ from 'lodash';
import { dateFilter2 } from '@/config/filter';

@Component({
  name: 'goals',
  components: { VGoalItem }
})
export default class Goals extends Mixin {
  get clientData() {
     const encodingQueries = this.decodingURLQueries();
    if (encodingQueries.coachClientId) {
      return this.groupListByDateDesc(goalModule.goalData, 'year')
    }

    return []
  }

  get clientGroupData() {
    const filterData = _.chain(goalModule.goalData)
      .map(data => {
        return {
          id: `${data['id']}`,
          name: `${data['coachClient']['firstName']} ${data['coachClient']['lastName']}`,
          content: data['content'],
          isLinked: data['isLinked'],
          percentCompleted: data['percentCompleted'],
          year: data['year'],
          created: dateFilter2(data['created']),
          updated: dateFilter2(data['updated']),
        };
      })
      .orderBy(['name'], ['asc'])
      .groupBy('name')
      .toPairs()
      .value()

    return filterData;
  }

  get isGroupGoals() {
     const encodingQueries = this.decodingURLQueries();
    return !encodingQueries.coachClientId
  }

  get goals() {
    return goalModule.goalData
  }


  public filterGroup(data: any) {
    return this.groupListByDateDesc(data, 'year')
  }

  mounted() {
    const encodingQueries = this.decodingURLQueries();
    let params: any = { coachId: encodingQueries.coachId as string, }
    if (encodingQueries.coachClientId) {
      params = {
        ...params,
        coachClientId: encodingQueries.coachClientId as string,
      }
    }
    if (encodingQueries.coachClientDepartment) {
      params = {
        ...params,
        coachClientDepartment: encodingQueries.coachClientDepartment as string,
      }
    }
    if (encodingQueries.coachClientCompanyName) {
      params = {
        ...params,
        coachClientCompanyName: encodingQueries.coachClientCompanyName as string,
      }
    }
    goalModule.loadGoals(params)
  }
}
